import type { SimpleFilterDefinition } from '@/sections/insights/queryBuilder/entities/types';
import { SSOIdentified } from '@/sections/insights/queryBuilder/entities/webpages/filters/SSOIdentified';
import { WebpageType } from '@/sections/insights/queryBuilder/entities/webpages/filters/Type';

/**
 * Get simple filter definitions for Webpage entity
 * Returns field names mapped to available values and operators
 *
 * @returns Array of filter names to SimpleFilterDefinition
 */
export function getWebpageSimpleFilters(): SimpleFilterDefinition[] {
  return [SSOIdentified, WebpageType];
}
